import * as React from "react"
import { cn } from "@/lib/utils"
import { Bar as RechartsBar, BarChart as RechartsBarChart, ResponsiveContainer, XAxis, YAxis, Tooltip } from "recharts"

interface ChartContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export function ChartContainer({
  className,
  children,
  ...props
}: ChartContainerProps) {
  return (
    <div className={cn("relative", className)} {...props}>
      {children}
    </div>
  )
}

interface ChartConfigProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export function ChartConfig({
  className,
  children,
  ...props
}: ChartConfigProps) {
  return (
    <div className={cn("grid gap-4", className)} {...props}>
      {children}
    </div>
  )
}

interface ChartTooltipProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export function ChartTooltip({
  className,
  children,
  ...props
}: ChartTooltipProps) {
  return (
    <div
      className={cn(
        "rounded-lg border bg-background p-2 shadow-md",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

interface ChartTooltipContentProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export function ChartTooltipContent({
  className,
  children,
  ...props
}: ChartTooltipContentProps) {
  return (
    <div className={cn("flex flex-col gap-1", className)} {...props}>
      {children}
    </div>
  )
}

interface ChartData {
  name: string;
  [key: string]: string | number; // Allow any additional numeric or string properties
}

interface ChartProps {
  data: ChartData[];
  children?: React.ReactNode;
}

export const Bar = RechartsBar
export const BarChart = ({ data, children, ...props }: ChartProps) => (
  <ResponsiveContainer width="100%" height={350}>
    <RechartsBarChart data={data} {...props}>
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      {children}
    </RechartsBarChart>
  </ResponsiveContainer>
)
